import { TextFieldComponent } from '../../../Common/PageBuilder/components/FormFields/TextField/text-field.component';
import { BlockTypeModel } from '../../../Common/PageBuilder/models/block-type.model';
import { TextFieldModel } from '../../../Common/PageBuilder/models/text-field.model';
import { TopTermsListChartBlockComponent } from '@Social/Shared/components/TopTerms/TopTermsListChartBlock/top-terms-list-chart-block.component';
import { TopTermsListChartDisplayElementModel } from './top-terms-list-chart-display-element.model';

export const topTermsListBlockType: BlockTypeModel = new BlockTypeModel(
    'TOP_TERMS_LIST',
    '',
    'fa fa-th-list',
    null,
    TopTermsListChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        )
    ],
    TopTermsListChartBlockComponent
);
